import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../../../contexts/authContext';

const DesignerLMSLayout = () => {
  const { user } = useAuth();
  console.log('[DesignerLMSLayout] Render:', { user: !!user });
  
  return (
    <div className="lms-layout">
      <main className="lms-main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
};

export default DesignerLMSLayout;
